import { Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'search-result-box',
  templateUrl: './search-result-box.component.html',
  styleUrls: ['./search-result-box.component.scss'],
  host: { class: 'search-result-box' },
})
export class SearchResultBoxComponent {
  @Input() menu = false;
  @Input() route?: string;
  @ViewChild('content') content!: ElementRef;

  @HostBinding('class') get classes() {
    const content = this.content?.nativeElement?.innerText !== '' ? 'has-content' : '';
    const route = this.route ? 'has-route' : '';
    return `${content} ${route}`;
  }
}
